import { Room } from 'models/index';

import * as Pagination from '../pagination';
import { endpoint, EndpointError } from '../endpoint';
import { PaginationParams } from './paginate';

export type PaginationPastRoomsResult = Pagination.Result<Room.PastRoomsItemT>;
export type PaginationPastRoomsError = EndpointError;

export type PaginationPastRoomsParams = PaginationParams;

export const paginatePastRooms = endpoint<
  PaginationPastRoomsParams,
  PaginationPastRoomsResult,
  PaginationPastRoomsError
>({
  method: 'POST',
  url: () => `/room/paginate-past-rooms`,
});
